"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8084],{

/***/ 48084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85893);











function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var BackgroundImage = next_dynamic__WEBPACK_IMPORTED_MODULE_14___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9261), __webpack_require__.e(9837)]).then(__webpack_require__.bind(__webpack_require__, 89837));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(89837)];
    }
  }
});
var Img = next_dynamic__WEBPACK_IMPORTED_MODULE_14___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(1036), __webpack_require__.e(7776), __webpack_require__.e(8996), __webpack_require__.e(9261), __webpack_require__.e(9572)]).then(__webpack_require__.bind(__webpack_require__, 7273));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7273)];
    }
  }
});


function Image(props) {
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      image = props.image,
      altText = props.altText,
      scale = props.scale,
      _props$customStyles = props.customStyles,
      customStyles = _props$customStyles === void 0 ? null : _props$customStyles,
      noAltText = props.noAltText,
      text = props.text,
      _props$elemId = props.elemId,
      elemId = _props$elemId === void 0 ? null : _props$elemId,
      _props$ariaHidden = props.ariaHidden,
      ariaHidden = _props$ariaHidden === void 0 ? false : _props$ariaHidden;

  if (image) {
    var _image$fields, _image$fields2, _image$fields2$asset, _image$fields2$asset$, _image$fields2$asset$2, _image$fields3, _image$fields4, _image$fields5, _image$fields6, _image$fields7, _rendition$fields, _rendition$fields2, _image$fields8, _image$fields9;

    var assetId = image == null ? void 0 : (_image$fields = image.fields) == null ? void 0 : _image$fields.assetId;
    var contentImageId = image == null ? void 0 : (_image$fields2 = image.fields) == null ? void 0 : (_image$fields2$asset = _image$fields2.asset) == null ? void 0 : (_image$fields2$asset$ = _image$fields2$asset.fields) == null ? void 0 : (_image$fields2$asset$2 = _image$fields2$asset$.file) == null ? void 0 : _image$fields2$asset$2.url;
    var alt = image == null ? void 0 : (_image$fields3 = image.fields) == null ? void 0 : _image$fields3.alternateText;
    var isPreload = (_image$fields4 = image.fields) == null ? void 0 : _image$fields4.isPreload;
    var isBannerImage = (_image$fields5 = image.fields) == null ? void 0 : _image$fields5.isBannerImage;
    var isProductPage = (_image$fields6 = image.fields) == null ? void 0 : _image$fields6.isProductPage;
    var rendition = (_image$fields7 = image.fields) == null ? void 0 : _image$fields7.imageRendition;
    var aspectRatio = rendition == null ? void 0 : (_rendition$fields = rendition.fields) == null ? void 0 : _rendition$fields.aspectRatio;
    var transformations = rendition == null ? void 0 : (_rendition$fields2 = rendition.fields) == null ? void 0 : _rendition$fields2.transformations;
    var customClassName = (_image$fields8 = image.fields) == null ? void 0 : _image$fields8.classNames;
    var format = ((_image$fields9 = image.fields) == null ? void 0 : _image$fields9.forcedFormat) || 'auto';
    var alignmentClassName = props.className;
    var resetImage = props.resetImage;
    var product = _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__/* .ImageConstants.product */ .j6.product;

    if (props.zoneClassName) {
      if (!customClassName) {
        customClassName = '';
      }

      customClassName += props.zoneClassName;
    }

    return children || props.forceBackground ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react__WEBPACK_IMPORTED_MODULE_13__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_16__["default"], {}),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(BackgroundImage, _objectSpread(_objectSpread({}, props), {}, {
        imageId: assetId,
        alt: alt ? alt : noAltText ? '' : 'product',
        contentImageId: contentImageId,
        isPreload: isPreload,
        isBannerImage: isBannerImage,
        widthToHeightRatio: aspectRatio,
        transformations: transformations,
        customClassName: customClassName,
        backgroundPosition: props.backgroundPosition,
        backgroundOffsetTop: props.backgroundOffsetTop,
        alignmentClassName: alignmentClassName,
        format: format,
        assetX: props.assetX,
        assetY: props.assetY,
        customStyles: customStyles,
        hasAssetParallax: props.hasAssetParallax,
        ariaHidden: ariaHidden,
        preloadImage: props.preloadImage,
        desktopBackgroundImage: props.desktopBackgroundImage,
        mobileBackgroundImage: props.mobileBackgroundImage,
        children: children
      }))
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react__WEBPACK_IMPORTED_MODULE_13__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_16__["default"], {}),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(Img, _objectSpread(_objectSpread({}, props), {}, {
        scale: scale,
        imageId: assetId,
        contentImageId: contentImageId,
        isPreload: isPreload,
        isBannerImage: isBannerImage,
        isProductPage: isProductPage,
        elemId: elemId,
        alt: altText ? altText : alt !== altText && !noAltText ? "".concat(alt, " ").concat(text ? text : '') : '',
        widthToHeightRatio: aspectRatio,
        transformations: transformations,
        offsetTop: props.offsetTop,
        offsetRight: props.offsetRight,
        offsetBottom: props.offsetBottom,
        offsetLeft: props.offsetLeft,
        customClassName: customClassName,
        alignmentClassName: alignmentClassName,
        format: format,
        resetImage: resetImage,
        ariaHidden: ariaHidden,
        imageClassName: props.imageClassName
      }))
    });
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
      children: children
    });
  }
}

/***/ })

}]);